/**
 * @generated SignedSource<<c3726d88a02716e82a9d0cc652229c29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ProfileRouteQuery$variables = {};
export type ProfileRouteQuery$data = {
  readonly viewer: {
    readonly id: string;
    readonly ticketingEmailSignature: string | null;
  } | null;
};
export type ProfileRouteQuery = {
  variables: ProfileRouteQuery$variables;
  response: ProfileRouteQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ticketingEmailSignature",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileRouteQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfileRouteQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "022c6e7a6a42704017cc1feed6fe8b59",
    "id": null,
    "metadata": {},
    "name": "ProfileRouteQuery",
    "operationKind": "query",
    "text": "query ProfileRouteQuery {\n  viewer {\n    id\n    ticketingEmailSignature\n  }\n}\n"
  }
};
})();

(node as any).hash = "f191620839b954d693fa8e542a144d50";

export default node;
